module.exports = __webpack_public_path__ + "img/bg.de269160.jpg";